import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_DOCUMENT_LINK } from './schema';

const MUTATION = gql`
  mutation CreateDocumentShareId($projectId: ID!, $mode: DocumentShareModeEnum!) {
    createDocumentShareId(projectId: $projectId, mode: $mode) {
      ...DocumentLink
    }
  }
  ${FRAGMENT_DOCUMENT_LINK}
`;

export const createDocumentShareId = async ({ projectId, mode }) => {
  const mutateOptions = {
    mutation: MUTATION,
    variables: { projectId, mode },
  };

  const result = await apolloClient.mutate(mutateOptions);
  return getSingleProp(result.data);
};
